module.exports = __webpack_public_path__ + "static/media/Poppins-Black.42480e9b.woff2";